import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../../Context/AuthContext';
import ServiceStatusContext from '../../../Context/ServiceStatusContext';
import './Navigation.scss';
import Searchbar from '../../../Components/Searchbar/Searchbar';
import ServiceStatusDisplay from '../../../Components/ServiceStatusPopup/ServiceStatusDisplay';

export default function Navigation() {
  const [authState] = useContext(AuthContext);
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState('');
  const [serviceStatusMessages] = useContext(ServiceStatusContext);

  const onSubmit = (e) => {
    history.push(`/app/dashboard/?s=${searchQuery}`);
    e.preventDefault();
  };

  return (
    <div className="navbar-wrapper">
      <div className="content-container">
        <Searchbar
          placeholder="Sök klient"
          onChange={(e) => setSearchQuery(e.target.value)}
          onSubmit={onSubmit}
        />
        {serviceStatusMessages.length > 0 ? (
          <ServiceStatusDisplay alerts={serviceStatusMessages} />
        ) : (
          ''
        )}
        <div className="user-name">
          <p>{authState?.user?.name ?? ''}</p>
        </div>
      </div>
    </div>
  );
}
